import { Building2, Users } from 'lucide-react'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  PageHeader,
} from '@atrvd/saas-ui'
import { useOrganizationsPage, type Organization } from '@/hooks/useOrganizationInvitations'
import { useTablePagination } from '@/hooks/useTablePagination'
import { OrganizationsTable } from '@/components/admin/OrganizationsTable'
import { SectionHeading } from '@/components/common/SectionHeading'
import { tableQueryState } from '@/components/common/queryErrorDisplay'

const NO_ORGANIZATIONS: Organization[] = []

/**
 * Admin page for viewing and managing organizations, paged on the server; the
 * Total card shows the server's count of every organization.
 */
export function OrganizationsPage() {
  // The total comes back with the page, so the footer goes through `forTotal`.
  const pagination = useTablePagination({ totalItems: undefined })
  const organizationsQuery = useOrganizationsPage({
    page: pagination.page,
    pageSize: pagination.pageSize,
  })
  const { data } = organizationsQuery
  const { dataTablePagination, knownTotal } = pagination.forTotal({
    total: data?.total,
    isFetching: organizationsQuery.isFetching,
  })
  const organizations = data?.organizations ?? NO_ORGANIZATIONS

  return (
    <div className="space-y-6">
      <PageHeader
        title="Organizations"
        description="View and manage tenant organizations"
      />

      {/* Stats Card */}
      <div className="grid gap-4 md:grid-cols-3">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Organizations</CardTitle>
            <Building2 className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{knownTotal ?? '—'}</div>
          </CardContent>
        </Card>
      </div>

      {/* A section, not a Card: DataTable draws its own card frame. */}
      <section className="space-y-4">
        <SectionHeading icon={Users}>All Organizations</SectionHeading>
        <OrganizationsTable
          organizations={organizations}
          pagination={dataTablePagination}
          {...tableQueryState(organizationsQuery, organizations.length)}
        />
      </section>
    </div>
  )
}
